import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CallbackBody } from '@callback/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccCallbackService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  requestCallback(body: CallbackBody): Observable<unknown> {
    const url = this.occEndpointsService.buildUrl('backcall');
    const params = Object.assign({}, body);
    if (params.phone) {
      params.phone = `7${params.phone}`;
    }

    return this.http.post<unknown>(url, null, {
      params: new HttpParams({
        fromObject: JSON.parse(JSON.stringify(params)),
      }),
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, this.occEndpointsService.getRawEndpointValue('backcall')),
    });
  }
}
